import React from 'react'
import { useFormContext } from 'react-hook-form'
import { renderText } from '../utils'

// 表示のみ英語化し、内部データは日本語のまま取り扱う
function ContactFormConfirmEn({
  onSubmit,
  onFix,
  privacyPolicyPath,
  className,
  requireAddress,
}) {
  const { getValues, handleSubmit } = useFormContext()
  const formValues = getValues()
  const showAddressFields = requireAddress(formValues.inquiryType)

  return (
    <>
      <h2 className={className}>Confirmation of transmitted contents</h2>
      <div className="inquiry_area">
        <p className="note">
          Fields marked with <span className="red">※</span> are required.
        </p>
        <form name="contact" method="post" onSubmit={handleSubmit(onSubmit)}>
          <table className="contact">
            <tbody>
              <tr id="Cnt1">
                <th className="must">Inquiry type</th>
                <td className="checkbox_square">
                  {formValues.inquiryType.map((inquiryType, index) => (
                    <span key={index}>{inquiryType}</span>
                  ))}
                </td>
              </tr>
              <tr id="Cnt2">
                <th className="must">Name (Kanji)</th>
                <td className="name">
                  <span>{formValues.nameKanji}</span>
                </td>
              </tr>
              <tr id="Cnt3">
                <th className="must">Name (Furigana)</th>
                <td className="name">
                  <span>{formValues.nameFurigana}</span>
                </td>
              </tr>
              <tr id="Cnt4" hidden={!showAddressFields}>
                <th>Contact address</th>
                <td className="address">
                  <div className="address_list">
                    <span>Postal code</span>
                    {formValues.postalCode}
                  </div>
                  <div className="address_list">
                    <span>Prefectures of Japan</span>
                    {formValues.prefecture}
                  </div>
                  <div className="address_list">
                    <span>Address</span>
                    {formValues.address1}
                  </div>
                  <div className="address_list">
                    <span>Building name</span>
                    {formValues.address2}
                  </div>
                </td>
              </tr>
              <tr id="Cnt5">
                <th className="must">Phone number</th>
                <td className="tel">
                  <span>{formValues.tel}</span>
                </td>
              </tr>
              <tr id="Cnt6">
                <th className="must">Email address</th>
                <td className="mail cont">
                  <span>{formValues.email}</span>
                </td>
              </tr>
              <tr>
                <th>Inquiry details</th>
                <td className="message">
                  <span>{renderText(formValues.inquiryBody)}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div className="send_area">
            <p>
              The information entered will be handled in accordance with our{' '}
              <a
                href={privacyPolicyPath}
                target="_blank"
                rel="noreferrer noopener"
              >
                privacy policy
              </a>
              .
            </p>
            <button>Submit</button>
            <button
              className="fix"
              onClick={(e) => {
                e.preventDefault()
                onFix()
              }}
            >
              Correct
            </button>
          </div>
        </form>
      </div>
    </>
  )
}

export { ContactFormConfirmEn }
